import assertNever from '@watershed/shared-util/src/assertNever';
import { ExprType } from '../expr_types';

export function sqlCast(sql: string, ty: ExprType): string {
  switch (ty.ty) {
    case 'string':
      return `(${sql})::TEXT`;
    case 'boolean':
      return `(${sql})::BOOLEAN`;
    case 'number':
    case 'quantity':
      return `(${sql})::DOUBLE`;
    case 'list':
      return sqlCast(sql, ty.elemTy) + '[]';
    case 'nullable':
      return sqlCast(sql, ty.baseTy);
    case 'null':
      // Chances are `sql` evaluates to `NULL`. In this case, DuckDB seems to do
      // some implicit type casting for NULL that we rely on, so we can't cast
      // to some convenient default ourselves
      return sql;
    case 'date':
      return `(${sql})::DATE`;
    case 'datetime':
      return `(${sql})::DATETIME`;
    default:
      assertNever(ty);
  }
}
